<template>
	<div class="tw-flex tw--mx-3">
		<div class="px-3 tw-w-3/5">
			<model-stepper
				:current-step="1"
				class="tw-mb-4"
				@code-step="loadCodeStep">
			</model-stepper>
			<p-card class="tw-mb-4 tw-flex tw-justify-between tw-items-center tw-gap-x-28">
				<v-select
					label="Todas las Áreas"
					class="select-core"
					hide-details
					:menu-props="{ contentClass: 'type-select-content' }"
					height="37"
					outline
					single-line
					autocomplete
					clearable
					:items="groups"
					item-value="id"
					item-text="name"
					@input="getGroup"
				></v-select>
				<input
					class="form-input"
					placeholder="Buscar Puesto"
					v-model="params.searchJob"
					@input="updateSearchParameter"
				/>
			</p-card>
			<p-card class="tw-flex-auto tw-flex tw-flex-col tw-justify-between">
				<p-empty-message v-if="!jobs.length">
					Seleccione las áreas de los puestos
				</p-empty-message>
				<div v-if="!!jobs.length" class="tw-grid tw-grid-col tw-grid-cols-5 tw-gap-4 ">
					<square-box
						v-for="(jobItem, index) in jobs"
						:name="jobItem.name"
						theme="secondary"
						:key="index"
						:checked="isSelectedJob(jobItem)"
						:clickable="true"
						:display-actions="false"
						@click="onJobClick(jobItem)"
					></square-box>
				</div>
			</p-card>
		</div>
		<div class="px-3 tw-w-2/5 fixed-section">
			<model-description
				:title="'PROCESO DE SELECCIÓN'"
				:subtitle="'DESCRIPCIÓN'">
				<div class="tw-my-4 tw-flex tw-flex-col tw-text-center tw-justify-center tw-items-center" slot="content">
					<p class="tw-mb-12 tw-text-left">
						1. Selecciona los puestos que ingresarán al proceso de selección.<br>
						2. Configura el proceso.<br>
						3. Configura las actividades del proceso de selección.<br>
						4. Configura la plantilla para la entrevista.
					</p>
					<p-button
						type="primary"
					>Mire nuestro tutorial paso a paso</p-button>
				</div>
			</model-description>
		</div>
	</div>
</template>

<script>
import modelStepper from '@/modules/recruitment/components/content/model-stepper';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PEmptyMessage from '@/modules/shared/components/ui/p-empty-message';
import SquareBox from '@/modules/shared/components/content/SquareBox';
import modelDescription from '@/modules/job-profile/components/content/model-description';
import PButton from '@/modules/shared/components/ui/p-button';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import { pathOr } from 'ramda';
import { mapState } from 'vuex';

export default {
	name: 'new-recruitment',
	data() {
		return {
			codeStep: {},
			params: {
				selectedId: null,
				searchJob: null,
			},
		};
	},
	beforeCreate() {
		this.$store.dispatch('recruitment/clearSelectedJobs');
		this.$store.dispatch('recruitment/loadRecruitmentConfig');
		this.params = {
			selectedId: null,
			searchJob: null,
		};
		this.$store.dispatch('recruitment/loadJobs', this.params);
		this.$store.dispatch('recruitment/loadGroups');
	},
	beforeMount() {
	},
	components: {
		modelStepper,
		PCard,
		PEmptyMessage,
		SquareBox,
		modelDescription,
		PButton,
		PHorizontalDivider,
	},
	methods: {
		loadCodeStep(obj) {
			this.codeStep = obj;
		},
		isSelectedJob(job) {
			return this.selectedJobs.id === job.id;
		},
		onJobClick(job) {
			this.$store.dispatch('recruitment/toggleJobSelection', job);
			this.$store.dispatch('recruitment/saveIdConfigProcess', null);
			this.goTo(this.codeStep.goTo);
		},
		getGroup(id) {
			this.params.selectedId = id;
			this.$store.dispatch('recruitment/loadJobs', this.params);
		},
		updateSearchParameter(event) {
			this.params.searchJob = event.target.value || null;
			this.$store.dispatch('recruitment/loadJobs', this.params);
		},
	},
	computed: {
		...mapState('recruitment', {
			jobs: pathOr([], ['jobs']),
			groups: pathOr([], ['groups']),
			selectedJobs: pathOr([], ['recruitmentFlow', 'selectedJobs']),
		}),
	},
	watch: {
		codeStep: {
			handler(newVal) {
				this.codeStep = newVal;
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.form-input {
	background: map-get($colors, white);
	border: 1px solid map-get($colors, gray-slider);
	border-radius: 4px;
	display: block;
	outline: none;
	color: map-get($colors, secondary);
	padding: 10px 20px;
	width: 40%;

	&::placeholder {
		color: map-get($colors, placeholder);
	}
}
.fixed-section {
	width: 30% !important;
	position: fixed;
	right: 95px;
}
</style>


// WEBPACK FOOTER //
// src/modules/recruitment/pages/new-recruitment.vue